export const API_URL: string = import.meta.env.VITE_API_URL;
export const BEARER: string = import.meta.env.VITE_BEARER;
export const PROJECT: string = import.meta.env.VITE_PROJECT;
